/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Cta_Title_AgentsInputs */

const en_cmp_cta_title_agents = /** @type {(inputs: Cmp_Cta_Title_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep your agents, add the proof`)
};

const id_cmp_cta_title_agents = /** @type {(inputs: Cmp_Cta_Title_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tetap pakai agen Anda, tambahkan buktinya`)
};

/**
* | output |
* | --- |
* | "Keep your agents, add the proof" |
*
* @param {Cmp_Cta_Title_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_cta_title_agents = /** @type {((inputs?: Cmp_Cta_Title_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Cta_Title_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_cta_title_agents(inputs)
	return en_cmp_cta_title_agents(inputs)
});